// src/Storage.js

import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";

import { Navigate } from "react-router-dom";

import { onAuthStateChanged, getAuth } from "firebase/auth";

import "./App.css";

import { db, auth } from "./FirebaseConfig";



import {

  PlusOutlined,

  CloudDownloadOutlined,

  DeleteOutlined,

  QuestionCircleOutlined,

  EditOutlined,

  UploadOutlined,

  ExclamationCircleOutlined,

  EyeOutlined,

} from "@ant-design/icons";



import {

  limit,
  startAfter,
  documentId,

  collection,

  getDocs,

  deleteDoc,

  doc,

  query,

  orderBy,

  updateDoc,

} from "firebase/firestore";



import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

import StomataLoader from "./StomataLoader";



import {

  Card,

  Image,

  Modal,

  Tooltip,

  FloatButton,

  Input,

  Form,

  Collapse,

  Empty,

  message,

  Button,

  Tour,

  Typography,

  Select,

  Upload,

  Skeleton,
  Alert,

  Checkbox,

  Tag,

  Space,

} from "antd";



import { useTranslation } from "react-i18next";



const { Search } = Input;

const { Text } = Typography;

const { Panel } = Collapse;

const { TextArea } = Input;



/* =======================

   CSV helpers

======================= */

function jsonEdit(json) {

  return json.map((row) => ({

    cultiverName: row.cultiverName,

    date: row.date,

    count: row.analysisStatus === "pending" ? "" : (row.size ?? ""),

    aperture: row.analysisStatus === "pending" ? "" : (row.aperture ?? ""),

    temperture: row.temperture,

    humidity: row.humidity,

    wether: row.wether,

    location: row.location,

    important: row.important,

    freetext: row.freeText,

    imageName: row.photopath,

    analysisStatus: row.analysisStatus === "pending" ? "pending" : "",

  }));

}



function jsonToCsv(json, delimiter) {

  if (!json || json.length === 0) return "";

  const edited = jsonEdit(json);

  const header = Object.keys(edited[0]).join(delimiter) + "\n";

  const body = edited

    .map((d) => Object.keys(d).map((key) => d[key]).join(delimiter))

    .join("\n");

  return header + body;

}



function jsonEdit2(json) {

  return json.map((row, index) => ({

    StomataID: index + 1,

    title: row.title,

    aperture: row.aperture,

    area: row.area,

    bottom: row.location?.bottom,

    top: row.location?.top,

    right: row.location?.right,

    left: row.location?.left,

  }));

}



function jsonToCsv2(json, delimiter) {

  if (!json || json.length === 0) return "";

  const edited = jsonEdit2(json);

  const header = Object.keys(edited[0]).join(delimiter) + "\n";

  const body = edited

    .map((d) => Object.keys(d).map((key) => d[key]).join(delimiter))

    .join("\n");

  return header + body;

}



function downloadTextFile(text, filename, mime = "text/csv;charset=utf-8;") {

  const blob = new Blob([text], { type: mime });

  const link = document.createElement("a");

  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);

  link.setAttribute("download", filename);

  link.style.visibility = "hidden";

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  URL.revokeObjectURL(url);

}



function getWindowDimensions() {

  const width = window.innerWidth;

  const height = window.innerHeight;

  return { width, height };

}



/* =======================
   全件検索用の共通処理
======================= */
const SEARCH_BATCH_SIZE = 400;
const SEARCH_PAGE_SIZE = 100;

function recordId(post) {
  return String(post?._docId || post?.photopath || "");
}

function normalizeSearchText(value) {
  return String(value ?? "").normalize("NFKC").toLocaleLowerCase();
}

function searchableValue(value) {
  if (value == null) return "";
  if (typeof value === "object") {
    if (typeof value.toDate === "function") {
      try { return value.toDate().toLocaleString(); } catch (_) { return ""; }
    }
    if (Array.isArray(value)) return value.map(searchableValue).join(" ");
    return Object.values(value).map(searchableValue).join(" ");
  }
  return String(value);
}

function getSearchText(post) {
  const fields = [
    post.cultiverName, post.cultivarName, post.photopath, post.date,
    post.location, post.temperture, post.temperature, post.humidity,
    post.wether, post.weather, post.freeText, post.important,
    post.userName, post.yoloxModel, post.segmentationModel,
    post.analysisStatus, post.timestamp,
    post.analysisStatus === "pending" ? "未解析 pending" : "解析済み completed",
  ];
  return normalizeSearchText(fields.map(searchableValue).join(" "));
}

function getPostTime(post) {
  const ts = post.timestamp;
  if (typeof ts?.toMillis === "function") return ts.toMillis();
  if (typeof ts?.toDate === "function") return ts.toDate().getTime();
  if (typeof ts === "number") return ts;
  const n = Date.parse(ts || post.date);
  return Number.isFinite(n) ? n : 0;
}

/* =======================

   Cover (lazy image) - memo

   ※選択でCardが再描画されても画像を再描画しない

======================= */

const CoverCell = React.memo(function CoverCell({ post, onUpload }) {

  const [inView, setInView] = useState(false);

  const [showUpload, setShowUpload] = useState(false);

  const holderRef = useRef(null);

  const { t } = useTranslation();



  useEffect(() => {

    const io = new IntersectionObserver(

      ([entry]) => {

        if (entry.isIntersecting) {

          setInView(true);

          io.disconnect();

        }

      },

      { rootMargin: "200px" }

    );

    if (holderRef.current) io.observe(holderRef.current);

    return () => io.disconnect();

  }, []);



  // 画像アップロード成功後、アップロード表示を閉じる

  useEffect(() => {

    if (post?.imageUploaded) setShowUpload(false);

  }, [post?.imageUploaded]);



  // Firebase SDKが発行する正規のダウンロードURLを使用する。

  // 固定トークンは別の画像で無効になるため使用しない。

  const [url, setUrl] = useState(null);

  useEffect(() => {

    let active = true;

    setUrl(null);

    setShowUpload(false);

    if (!inView || !post?.userName || !post?.cultiverName || !post?.photopath) return;

    const objectPath = `${post.userName}/${post.cultiverName}/${post.photopath}`;

    getDownloadURL(storageRef(getStorage(), objectPath))

      .then((downloadUrl) => { if (active) setUrl(downloadUrl); })

      .catch((error) => {

        console.warn("Storage image URL unavailable", objectPath, error?.code);

        if (active) setShowUpload(true);

      });

    return () => { active = false; };

  }, [inView, post?.userName, post?.cultiverName, post?.photopath, post?.imageUploaded]);



  if (!inView) {

    return (

      <div ref={holderRef} style={{ height: 140 }}>

        <Skeleton.Image active style={{ width: "100%", height: 140 }} />

      </div>

    );

  }



  if (showUpload) {

    return (

      <div style={{ textAlign: "center", padding: 16, minHeight: 140 }}>

        <Typography.Text type="secondary" style={{ display: "block", marginBottom: 10 }}>

          画像を表示できません。Androidアプリからバックアップ状況を確認してください。

        </Typography.Text>

        <Button size="small" onClick={() => window.location.assign("/UsersManual")}>

          詳細

        </Button>

      </div>

    );

  }



  if (!url) {

    return <div style={{ height: 140 }}><Skeleton.Image active style={{ width: "100%", height: 140 }} /></div>;

  }



  return (

    <Image

      preview={{

        mask: (

          <>

            <EyeOutlined /> {t("storage.previewMask")}

          </>

        ),

        destroyOnClose: true,

      }}

      loading="lazy"

      alt={t("storage.imageAlt")}

      src={url}

      className="card-image"

      style={{

        width: "100%",

        height: "auto",

        objectFit: "cover",

        borderRadius: 4,

      }}

      onError={() => setShowUpload(true)}

      placeholder={

        <Skeleton.Image active style={{ width: "100%", height: 160 }} />

      }

    />

  );

});



/* Human-readable display names; Firebase model filenames are unchanged. */

const MODEL_DISPLAY_NAMES = {

  '20241021_arabi_1920_1920__single_yolox_s_3_float16.tflite': 'Arabidopsis',

  'eggplant_yolox_s_1920_untransposed_float16.tflite': 'Eggplant',

  'strawberry_combined_yolox_s_1920_1920_untranposed_float16.tflite': 'Strawberry',

  'cabbage_yolox_1920_1920_untranposed_float16.tflite': 'Cabbage',

  'frillice_lettuce_yolox_1920_1920_untranposed_float16.tflite': 'Lettuce',

  'wheat2_yolox_s_float16.tflite': 'Wheat',

  'rose_yolox_1920_1920_untranposed_float16.tflite': 'Rose',

  'potato_yolox_s__single_float16.tflite': 'Potato',

  '20241028_bok_1920_1920__single_yolox_s_float16.tflite': 'Bok choy',

  '2024-12-16_grape_1920_1920__single_yolox_s_float16.tflite': 'Grape',

  'tomato2_yolox_1920_1920_untranposed_float16.tflite': 'Tomato',

  '20251020_tomato_yolox_s_1920x1920_f16.tflite': 'Tomato',

  '20250421_hop_cascade_yolox_s__1920x1920_float16.tflite': 'Hop',

  '20250617_turkey_gikyo_yxs_f16.tflite': 'Lisianthus',

  'corn_yolox_s__single_float16.tflite': 'Sweet corn',

  '20250717_dent_corn_yolox_s_f16.tflite': 'Dent corn',

  '20250410_spinach_yolox_s_single_float16_1920.tflite': 'Spinach',

  '20250910_sorghum_yoloxs_1920x1920_f16.tflite': 'Sorghum',

  '20251008_soy_yolox_s_f16.tflite': 'Soybean',

  '20251124_pennycress_yolox_s_1920x1920_f16.tflite': 'Pennycress',

  '2026-03-12_kuroyona-v1-1_single_20260312_1920_1920_float16.tflite': 'Pongamia',

  '2026-03-19_sugarcane-v1-0_single_20260319_1920_1920_float16.tflite': 'Sugarcane',

  '20260416-basil-v1-1_single_20260416_1920_1920_float16.tflite': 'Basil',

  'open-closed_any-stomata_v-0-2t_float16.tflite': 'General-purpose model',

};

const MODEL_DISPLAY_NAMES_JA = {

  '20241021_arabi_1920_1920__single_yolox_s_3_float16.tflite': 'シロイヌナズナ',

  'eggplant_yolox_s_1920_untransposed_float16.tflite': 'ナス',

  'strawberry_combined_yolox_s_1920_1920_untranposed_float16.tflite': 'イチゴ',

  'cabbage_yolox_1920_1920_untranposed_float16.tflite': 'キャベツ',

  'frillice_lettuce_yolox_1920_1920_untranposed_float16.tflite': 'レタス',

  'wheat2_yolox_s_float16.tflite': 'コムギ',

  'rose_yolox_1920_1920_untranposed_float16.tflite': 'バラ',

  'potato_yolox_s__single_float16.tflite': 'ジャガイモ',

  '20241028_bok_1920_1920__single_yolox_s_float16.tflite': 'チンゲンサイ',

  '2024-12-16_grape_1920_1920__single_yolox_s_float16.tflite': 'ブドウ',

  'tomato2_yolox_1920_1920_untranposed_float16.tflite': 'トマト',

  '20251020_tomato_yolox_s_1920x1920_f16.tflite': 'トマト',

  '20250421_hop_cascade_yolox_s__1920x1920_float16.tflite': 'ホップ',

  '20250617_turkey_gikyo_yxs_f16.tflite': 'トルコギキョウ',

  'corn_yolox_s__single_float16.tflite': 'スイートコーン',

  '20250717_dent_corn_yolox_s_f16.tflite': 'デントコーン',

  '20250410_spinach_yolox_s_single_float16_1920.tflite': 'ホウレンソウ',

  '20250910_sorghum_yoloxs_1920x1920_f16.tflite': 'ソルガム',

  '20251008_soy_yolox_s_f16.tflite': 'ダイズ',

  '20251124_pennycress_yolox_s_1920x1920_f16.tflite': 'ペニークレス',

  '2026-03-12_kuroyona-v1-1_single_20260312_1920_1920_float16.tflite': 'クロヨナ',

  '2026-03-19_sugarcane-v1-0_single_20260319_1920_1920_float16.tflite': 'サトウキビ',

  '20260416-basil-v1-1_single_20260416_1920_1920_float16.tflite': 'バジル',

  'open-closed_any-stomata_v-0-2t_float16.tflite': '汎用モデル',

};

function shortModelName(filename, isJapanese) {

  if (typeof filename !== "string" || !filename.trim()) return "";

  const name = filename.trim();

  const names = isJapanese ? MODEL_DISPLAY_NAMES_JA : MODEL_DISPLAY_NAMES;

  if (names[name]) return names[name];

  // Do not infer a crop from an unknown model name.

  return name.replace(/\.tflite$/i, "").replace(/_float16$/i, "").replace(/_f16$/i, "");

}



const ModelOverlay = React.memo(function ModelOverlay({ post }) {

  const { i18n } = useTranslation();

  const isJapanese = (i18n.resolvedLanguage || i18n.language || "ja").toLowerCase().startsWith("ja");

  const yolox = post?.yoloxModel;

  const segment = post?.segmentationModel;

  if (!yolox && !segment) return null;

  const pending = post?.analysisStatus === "pending";

  const primary = yolox || segment;

  const prefix = pending ? (isJapanese ? "予定" : "Planned") : "AI";

  const fullTitle = [

    pending ? (isJapanese ? "推論予定モデル" : "Planned inference models") : (isJapanese ? "使用した推論モデル" : "Inference models used"),

    yolox ? `YOLOX: ${yolox}` : null,

    segment ? `Segmentation: ${segment}` : null,

  ].filter(Boolean).join("\n");

  return (

    <div

      title={fullTitle}

      aria-label={fullTitle.replace(/\n/g, ", ")}

      style={{

        position: "absolute", left: 7, bottom: 7, zIndex: 3,

        maxWidth: "calc(100% - 14px)", padding: "4px 7px",

        background: "rgba(0, 0, 0, 0.76)", color: "#fff",

        borderRadius: 5, fontSize: 11, lineHeight: "16px",

        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",

        pointerEvents: "none",

      }}

    >

      {prefix}: {shortModelName(primary, isJapanese)}

    </div>

  );

});



/* =======================

   Card Body - memo

   ※選択の枠色変更で results.map 等を回さない

======================= */

const CardBody = React.memo(function CardBody({ post, t }) {

  const pending = post.analysisStatus === "pending";

  return (

    <div>

      <div className="resultText">

        {t("storage.date")}: {post.date}

      </div>

      <div className="resultText">

        {t("storage.cultivar")}: {post.cultiverName}

      </div>

      {pending ? (

        <Tag color="orange">未解析 / Pending analysis</Tag>

      ) : (

        <>

          <div className="resultText">

            {t("storage.aperture")}: {Number(post.aperture ?? 0).toFixed(2)}

          </div>

          <div className="resultText">

            {t("storage.count")}: {post.size ?? 0}

          </div>

        </>

      )}

      <div className="resultText">

        {t("storage.location")}: {post.location}

      </div>

      <div className="resultText">

        {t("storage.temperature")}: {post.temperture}

      </div>

      <div className="resultText">

        {t("storage.humidity")}: {post.humidity}

      </div>

      <div className="resultText">

        {t("storage.weather")}: {post.wether}

      </div>

      <div className="resultText">

        {t("storage.memo")}: {post.freeText}

      </div>



      {!pending && <Collapse accordion size="small" bordered={false}>

        <Panel header={t("storage.details")}>

          {post.results ? (

            post.results.map((results, index) => {

              const isClose = results.idClass > 0;

              const color = isClose ? "blue" : "red";

              const labelKey = isClose ? "close" : "open";



              return (

                <div

                  key={index}

                  style={{ display: "flex", alignItems: "center", gap: 8 }}

                >

                  <Text style={{ width: 28, textAlign: "right" }}>

                    {index}:

                  </Text>



                  <Tag

                    color={color}

                    style={{ minWidth: 64, textAlign: "center" }}

                  >

                    {t(`storage.${labelKey}`)}

                  </Tag>



                  <Text>

                    {Number(results.aperture ?? 0) > 0 &&

                      `${Number(results.aperture).toFixed(2)}µm `}

                    {Number(results.area ?? 0) > 0 &&

                      `${Number(results.area).toFixed(1)}µm²`}

                  </Text>

                </div>

              );

            })

          ) : (

            <Empty />

          )}

        </Panel>

      </Collapse>}

    </div>

  );

});



/* =======================

   StorageCard - memo

   ※選択で「そのカードだけ」再描画

======================= */

const CARD_STYLE_BASE = {

  width: 280,

  margin: 10,

  backgroundColor: "#ffffffff",

  border: "1px solid #f0f0f0",

  boxShadow: "none",

};



const CARD_STYLE_SELECTED = {

  width: 280,

  margin: 10,

  backgroundColor: "#d1e9ffff",

  border: "2px solid #1890ff",

  boxShadow: "0 0 8px rgba(24,144,255,0.6)",

};



const StorageCard = React.memo(function StorageCard({

  post,

  selected,

  onToggleSelect,

  onShowDeleteModal,

  onShowEditModal,

  onDownloadStomataResults,

  onUploadImage,

  t,

  ref3,

  ref4,

  ref5,

}) {

  const key = recordId(post);



  return (

    <Card

      key={key}

      className="Strage_Card"

      style={selected ? CARD_STYLE_SELECTED : CARD_STYLE_BASE}

      actions={[

        <Tooltip

          placement="topLeft"

          title={t("storage.delete")}

          color="red"

          key="deleteTip"

        >

          <DeleteOutlined

            ref={ref3}

            key="delete"

            onClick={(e) => {

              e.stopPropagation();

              onShowDeleteModal(key);

            }}

          />

        </Tooltip>,

        <Tooltip

          placement="topLeft"

          title={t("storage.edit")}

          color="green"

          key="editTip"

        >

          <EditOutlined

            ref={ref4}

            key="edit"

            onClick={(e) => {

              e.stopPropagation();

              onShowEditModal(post);

            }}

          />

        </Tooltip>,

        <Tooltip

          placement="topLeft"

          title={t("storage.download")}

          color="blue"

          key="dlTip"

        >

          <CloudDownloadOutlined

            ref={ref5}

            key="download"

            onClick={(e) => {

              e.stopPropagation();

              onDownloadStomataResults(post);

            }}

          />

        </Tooltip>,

      ]}

      cover={

        <div className="box" style={{ position: "relative" }}>

          <Checkbox

            checked={selected}

            onChange={() => onToggleSelect(key)}

            style={{

              position: "absolute",

              top: 4,

              right: 6,

              zIndex: 10,

              padding: 2,

            }}

            onClick={(e) => e.stopPropagation()}

          />

          <CoverCell post={post} onUpload={onUploadImage} />

          <ModelOverlay post={post} />

          <div className="important_item">{post.important}</div>

          <div className="pathText">{(post.photopath || "").split(".")[0]}</div>

        </div>

      }

    >

      <CardBody post={post} t={t} />

    </Card>

  );

});



/* =======================

   Main

======================= */

function Storage() {

  const { t } = useTranslation();



  const [posts, setPosts] = useState([]);
  const [postsOwner, setPostsOwner] = useState(null);

  const [count, setCount] = useState(1000);



  // ページ全体のロード（初回fetchなど）

  const [loading, setLoading] = useState(true);



  // 編集保存中（ページ全体をローダーにしない）

  const [saving, setSaving] = useState(false);



  const [delPath, setDelPath] = useState();

  const [isModalOpen, setIsModalOpen] = useState(false);



  const [user, setUser] = useState();

  const [windowDimensions, setWindowDimensions] = useState(

    getWindowDimensions()

  );

  const [searchTerm, setSearchTerm] = useState("");

  const [analysisFilter, setAnalysisFilter] = useState("all");
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [authReady, setAuthReady] = useState(false);
  const searchCacheRef = useRef({ email: null, records: new Map(), cursor: null, complete: false });
  const searchFetchPromiseRef = useRef(null);
  const deletedIdsRef = useRef(new Set());
  const [searchCacheVersion, setSearchCacheVersion] = useState(0);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState("");
  const [searchRetry, setSearchRetry] = useState(0);
  const [searchVisibleCount, setSearchVisibleCount] = useState(SEARCH_PAGE_SIZE);
  const userEmail = user?.email || null;
  const globalSearch = Boolean(searchTerm.trim()) || analysisFilter !== "all";




  const [open, setOpen] = useState(false);

  const [editFields, setEditFields] = useState({});



  const ref1 = useRef(null);

  const ref2 = useRef(null);

  const ref3 = useRef(null);

  const ref4 = useRef(null);

  const ref5 = useRef(null);



  const [openTour, setOpenTour] = useState(false);



  // ★ Set化（ここが一番効く）

  const [selectedKeys, setSelectedKeys] = useState(() => new Set());

  const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false);

  const [bulkDeleteKeys, setBulkDeleteKeys] = useState([]);

  // 入力中にも検索。フィルタ処理だけを180ms遅らせる。
  useEffect(() => {
    if (!searchTerm.trim()) {
      setDebouncedTerm("");
      return undefined;
    }
    const timer = setTimeout(() => setDebouncedTerm(searchTerm), 180);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  // ユーザーが変わったら別アカウントの検索結果を残さない。
  useEffect(() => {
    searchCacheRef.current = { email: userEmail, records: new Map(), cursor: null, complete: false };
    searchFetchPromiseRef.current = null;
    deletedIdsRef.current = new Set();
    setSearchCacheVersion(0);
    setSearchError("");
    setSearchLoading(false);
    setSearchVisibleCount(SEARCH_PAGE_SIZE);
    setSelectedKeys(new Set());
    setCount(1000);
    if (!userEmail) {
      setPosts([]);
      setPostsOwner(null);
    }
  }, [userEmail]);

  const patchSearchCache = useCallback((id, patch) => {
    const cache = searchCacheRef.current;
    const old = cache.records.get(id);
    if (!old) return;
    cache.records.set(id, { ...old, ...patch });
    setSearchCacheVersion((n) => n + 1);
  }, []);

  const removeFromSearchCache = useCallback((ids) => {
    const cache = searchCacheRef.current;
    ids.forEach((id) => {
      deletedIdsRef.current.add(id);
      cache.records.delete(id);
    });
    setSearchCacheVersion((n) => n + 1);
  }, []);

  // documentId順に分割取得するため、timestampのない古いデータも検索対象。
  const fetchSearchBatch = useCallback(async (email) => {
    const cache = searchCacheRef.current;
    if (cache.email !== email || cache.complete) return;
    if (searchFetchPromiseRef.current) {
      await searchFetchPromiseRef.current;
      return;
    }
    const promise = (async () => {
      const constraints = [orderBy(documentId())];
      if (cache.cursor) constraints.push(startAfter(cache.cursor));
      constraints.push(limit(SEARCH_BATCH_SIZE));
      const snap = await getDocs(query(collection(db, email), ...constraints));
      if (searchCacheRef.current !== cache) return;
      snap.docs.forEach((item) => {
        if (!deletedIdsRef.current.has(item.id) && !cache.records.has(item.id)) {
          cache.records.set(item.id, { ...item.data(), _docId: item.id });
        }
      });
      if (snap.docs.length) cache.cursor = snap.docs[snap.docs.length - 1];
      if (snap.size < SEARCH_BATCH_SIZE) cache.complete = true;
      setSearchCacheVersion((n) => n + 1);
    })();
    searchFetchPromiseRef.current = promise;
    try { await promise; }
    finally {
      if (searchFetchPromiseRef.current === promise) searchFetchPromiseRef.current = null;
    }
  }, []);

  // 一度取得した分は再利用。検索を解除したら追加取得を中断。
  useEffect(() => {
    if (!globalSearch || !userEmail) {
      setSearchLoading(false);
      return undefined;
    }
    let cancelled = false;
    async function run() {
      setSearchError("");
      setSearchLoading(!searchCacheRef.current.complete);
      try {
        while (!cancelled && !searchCacheRef.current.complete) {
          await fetchSearchBatch(userEmail);
        }
      } catch (error) {
        console.error("Full storage search failed:", error);
        if (!cancelled) setSearchError(error?.message || "検索データの取得に失敗しました");
      } finally {
        if (!cancelled) setSearchLoading(false);
      }
    }
    run();
    return () => { cancelled = true; };
  }, [globalSearch, userEmail, searchRetry, fetchSearchBatch]);

  useEffect(() => {
    setSearchVisibleCount(SEARCH_PAGE_SIZE);
  }, [debouncedTerm, analysisFilter]);




  /* ---------- selection ---------- */

  const toggleSelect = useCallback((key) => {

    setSelectedKeys((prev) => {

      const next = new Set(prev);

      if (next.has(key)) next.delete(key);

      else next.add(key);

      return next;

    });

  }, []);



  /* ---------- upload backup image ---------- */

  const handleUploadImage = useCallback(

    async (e, post) => {

      const file = e.target.files?.[0];

      if (!file) return;



      const storage = getStorage();

      const path = `${post.userName}/${post.cultiverName}/${post.photopath}`;

      const imageRef = storageRef(storage, path);



      try {

        await uploadBytes(imageRef, file);

        message.success(t("storage.uploadSuccess", { defaultValue: "Uploaded." }));



        const email = getAuth().currentUser?.email;

        if (email) {

          const docRef = doc(db, email, recordId(post));

          await updateDoc(docRef, { imageUploaded: true });



          // ★ 全件再取得しない：ローカル更新

          setPosts((prev) =>

            prev.map((p) =>

              recordId(p) === recordId(post) ? { ...p, imageUploaded: true } : p

            )

          );
          patchSearchCache(recordId(post), { imageUploaded: true });
        }
      } catch (error) {
        console.error("Upload failed:", error);

        message.error(t("storage.uploadFail", { defaultValue: "Upload failed." }));

      }

    },

    [t, patchSearchCache]
  );

  /* ---------- fetch posts ---------- */

  useEffect(() => {

    let active = true;
    async function fetchPosts() {

      if (!userEmail) return;

      setLoading(true);



      const email = userEmail;

      if (!email) {

        setLoading(false);

        return;

      }



      try {

        const snapShot = await getDocs(

          query(collection(db, email), orderBy("timestamp", "desc"), limit(count))

        );

        const rawPosts = snapShot.docs.map((d) => ({ ...d.data(), _docId: d.id }));
        if (active) {
          setPosts(rawPosts);
          setPostsOwner(email);
        }

      } catch (e) {

        console.error(e);

      } finally {
        if (active) setLoading(false);
      }
    }
    fetchPosts();
    return () => { active = false; };
  }, [count, userEmail]);



  /* ---------- resize ---------- */

  useEffect(() => {

    function handleResize() {

      setWindowDimensions(getWindowDimensions());

    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);

  }, []);



  /* ---------- auth ---------- */

  useEffect(() => {

    const unsub = onAuthStateChanged(auth, (currentUser) => {

      setUser(currentUser);
      setAuthReady(true);
    });

    return () => unsub();

  }, []);



  /* ---------- delete ---------- */

  const showModal = useCallback((path) => {

    setDelPath(path);

    setIsModalOpen(true);

  }, []);



  const handleOk = useCallback(async () => {

    if (!delPath) return;

    await deleteDocument(delPath);

    setIsModalOpen(false);

  }, [delPath]);



  const handleCancel = useCallback(() => {

    setIsModalOpen(false);

  }, []);



  const deleteDocument = useCallback(

    async (path) => {

      if (!path) return;

      const email = getAuth().currentUser?.email;

      if (!email) return;



      await deleteDoc(doc(db, email, path.toString()));



      // ★ 全件再取得しない：ローカルから即削除

      setPosts((prev) => prev.filter((p) => recordId(p) !== path.toString()));
      removeFromSearchCache([path.toString()]);

      setSelectedKeys((prev) => {

        const next = new Set(prev);

        next.delete(path.toString());

        return next;

      });



      message.success(t("storage.deleteSuccess", { defaultValue: "Deleted." }));

    },

    [t, removeFromSearchCache]
  );

  /* ---------- load more ---------- */

  const increment = useCallback(() => {

    setCount(posts.length + 1000);

  }, [posts.length]);



  /* ---------- edit ---------- */

  const showEditModal = useCallback((post) => {

    setOpen(true);

    setEditFields(post);

  }, []);



  const EdithandleOk = useCallback(() => {

    setSaving(true);

    update();

  }, [editFields]); // editFields 更新で再生成されてもOK（ボタン押す時だけ）



  const EdithandleCancel = useCallback(() => {

    setOpen(false);

  }, []);



  async function update() {

    try {

      const email = getAuth().currentUser?.email;

      if (!email) return;



      const washingtonRef = doc(db, email, recordId(editFields));



      const patch = {

        location: editFields.location,

        temperture: editFields.temperture,

        humidity: editFields.humidity,

        wether: editFields.wether,

        freeText: editFields.freeText,

        important: editFields.important,

      };



      await updateDoc(washingtonRef, patch);



      // ★ 全件再取得しない：ローカル更新

      setPosts((prev) =>

        prev.map((p) =>

            recordId(p) === recordId(editFields) ? { ...p, ...patch } : p

        )

      );
      patchSearchCache(recordId(editFields), patch);

      message.success(t("common.updated", { defaultValue: "Updated." }));

      setOpen(false);

    } catch (e) {

      console.error(e);

      message.error(t("common.updateFailed", { defaultValue: "Update failed." }));

    } finally {

      setSaving(false);

    }

  }



  /* ---------- 全件検索 + フィルタ ---------- */
  const filteredPosts = useMemo(() => {
    // searchCacheVersionの更新でref内の検索結果を再計算する。
    const currentPosts = postsOwner === userEmail ? posts : [];
    const source = globalSearch
      ? (() => {
          const merged = new Map();
          currentPosts.forEach((p) => merged.set(recordId(p), p));
          if (searchCacheRef.current.email === userEmail) {
            searchCacheRef.current.records.forEach((p, id) => merged.set(id, p));
          }
          deletedIdsRef.current.forEach((id) => merged.delete(id));
          return Array.from(merged.values());
        })()
      : currentPosts;

    const terms = normalizeSearchText(debouncedTerm.trim()).split(/\s+/).filter(Boolean);
    return source.filter((post) => {
      const pending = post.analysisStatus === "pending";
      if (analysisFilter === "pending" && !pending) return false;
      if (analysisFilter === "completed" && pending) return false;
      if (!terms.length) return true;
      const text = getSearchText(post);
      return terms.every((word) => text.includes(word));
    }).sort((a, b) => getPostTime(b) - getPostTime(a));
  }, [posts, postsOwner, userEmail, globalSearch, debouncedTerm, analysisFilter, searchCacheVersion]);

  // 大量の検索結果を一度にDOMへ追加しない（検索対象は全件のまま）。
  const visiblePosts = useMemo(() => globalSearch
    ? filteredPosts.slice(0, searchVisibleCount)
    : filteredPosts,
  [globalSearch, filteredPosts, searchVisibleCount]);
  const allSearchLoaded = searchCacheRef.current.complete;
  const searchedDocumentCount = searchCacheRef.current.records.size;

  /* ---------- bulk selection ---------- */

  const selectAll = useCallback(() => {

    const keys = visiblePosts.map(recordId);

    setSelectedKeys(new Set(keys));

  }, [visiblePosts]);



  const clearSelection = useCallback(() => {

    setSelectedKeys(new Set());

  }, []);



  /* ---------- download ---------- */

  const downloadTimeSeries = useCallback(() => {

    const csv = jsonToCsv(posts, ",");

    downloadTextFile(csv, "stomatascope_data.csv");

    message.success(t("storage.downloadSuccess", { defaultValue: "Downloaded." }));

  }, [posts, t]);



  const downloadStomataResults = useCallback(

    (post) => {

      if (post?.analysisStatus === "pending" || !Array.isArray(post?.results) || !post.results.length) {

        message.warning(t("storage.noResults", { defaultValue: "No data." }));

        return;

      }

      const csv = jsonToCsv2(post.results, ",");

      const name = (post.photopath || "export").split(".")[0] + ".csv";

      downloadTextFile(csv, name);

      message.success(t("storage.downloadSuccess", { defaultValue: "Downloaded." }));

    },

    [t]

  );



  /* ---------- tour steps ---------- */

  const steps = [

    {

      title: t("storage.tour.display.title"),

      description: t("storage.tour.display.desc"),

      target: () => ref1.current,

      placement: "left",

    },

    {

      title: t("storage.tour.download.title"),

      description: t("storage.tour.download.desc"),

      target: () => ref2.current,

      placement: "left",

    },

    {

      title: t("storage.tour.delete.title"),

      description: t("storage.tour.delete.desc"),

      target: () => ref3.current,

    },

    {

      title: t("storage.tour.edit.title"),

      description: t("storage.tour.edit.desc"),

      target: () => ref4.current,

    },

    {

      title: t("storage.tour.stomataDownload.title"),

      description: t("storage.tour.stomataDownload.desc"),

      target: () => ref5.current,

    },

  ];



  /* =======================

     Render

  ======================= */

  if (!authReady || (user && loading)) {

    return (

      <div className="spin">

        <StomataLoader />

      </div>

    );

  }



  if (!user) return <Navigate to={"/Top/"} />;



  const selectedCount = selectedKeys.size;



  return (

    <>

      <Tour

        open={openTour}

        onClose={() => setOpenTour(false)}

        mask={true}

        steps={steps}

        locale={{

          Next: t("tour.next"),

          Prev: t("tour.prev"),

          Done: t("tour.finish"),

        }}

      />



      {/* toolbar */}
      <div className="storage-toolbar">
        <Space wrap style={{ width: "100%" }}>
          <Search
            placeholder="品種・日付・場所・メモ・画像名・モデル名を検索"
            aria-label="保存データを検索"
            allowClear
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onSearch={(value) => {
              setSearchTerm(value);
              setDebouncedTerm(value);
            }}
            style={{ width: 360, maxWidth: "100%" }}
          />
          <Select
            aria-label="解析状態"
            value={analysisFilter}
            onChange={setAnalysisFilter}
            style={{ width: 145 }}
            options={[
              { value: "all", label: "すべて" },
              { value: "pending", label: "未解析" },
              { value: "completed", label: "解析済み" },
            ]}
          />
          <Button
            onClick={() => {
              setSearchTerm("");
              setDebouncedTerm("");
              setAnalysisFilter("all");
            }}
            disabled={!globalSearch}
          >
            {t("storage.clear", { defaultValue: "クリア" })}
          </Button>
          {globalSearch && (
            <Button
              disabled={!filteredPosts.length || !allSearchLoaded}
              onClick={() => {
                downloadTextFile(jsonToCsv(filteredPosts, ","), "stomatascope_search_results.csv");
                message.success(t("storage.downloadSuccess", { defaultValue: "Downloaded." }));
              }}
            >
              検索結果をCSV
            </Button>
          )}
        </Space>

        <div style={{ marginTop: 10, marginBottom: 8 }}>
          {globalSearch ? (
            <Space wrap>
              <Text strong>検索結果 {filteredPosts.length.toLocaleString()} 件</Text>
              <Text type="secondary">（表示 {visiblePosts.length.toLocaleString()} 件）</Text>
              {searchLoading ? (
                <Text type="secondary">全データを検索中… {searchedDocumentCount.toLocaleString()} 件確認済み。結果はまだ途中です。</Text>
              ) : allSearchLoaded ? (
                <Text type="success">全保存データの検索完了（{searchedDocumentCount.toLocaleString()} 件）</Text>
              ) : (
                <Text type="secondary">全件検索は未完了です</Text>
              )}
            </Space>
          ) : (
            <Text type="secondary">
              最新 {posts.length.toLocaleString()} 件を表示中。古いデータも探す場合は検索欄を使用してください。
            </Text>
          )}
        </div>
        {globalSearch && searchError && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 12 }}
            message="全件検索を途中で停止しました。現在の結果は一部のみです。"
            description={searchError}
            action={<Button size="small" onClick={() => setSearchRetry((n) => n + 1)}>再試行</Button>}
          />
        )}

        {selectedCount > 0 && (

          <div style={{ marginTop: 8 }}>

            <Space wrap>

              <Text strong>

                {t("storage.selectedCount", { count: selectedCount })}

              </Text>



              <Button

                danger

                size="small"

                onClick={() => {

                  setBulkDeleteKeys(Array.from(selectedKeys));

                  setIsBulkDeleteModalOpen(true);

                }}

              >

                {t("storage.deleteSelected")}

              </Button>



              <Button size="small" onClick={clearSelection}>

                {t("storage.clearSelection")}

              </Button>



              <Button size="small" onClick={selectAll}>

                {t("storage.selectAll")}

              </Button>

            </Space>

          </div>

        )}

      </div>



      <div className="cards-container">

        <Image.PreviewGroup preview={{ destroyOnClose: true }}>

          {visiblePosts.map((post) => {

            const key = recordId(post);

            const selected = selectedKeys.has(key);



            return (

              <StorageCard

                key={key}

                post={post}

                selected={selected}

                onToggleSelect={toggleSelect}

                onShowDeleteModal={showModal}

                onShowEditModal={showEditModal}

                onDownloadStomataResults={downloadStomataResults}

                onUploadImage={handleUploadImage}

                t={t}

                ref3={ref3}

                ref4={ref4}

                ref5={ref5}

              />

            );

          })}

        </Image.PreviewGroup>

      </div>



      {globalSearch && !visiblePosts.length && !searchLoading && !searchError && (
        <Empty description="条件に一致するデータはありません" style={{ marginTop: 32 }} />
      )}
      {globalSearch && searchVisibleCount < filteredPosts.length && (
        <div style={{ textAlign: "center", padding: 20 }}>
          <Button onClick={() => setSearchVisibleCount((n) => n + SEARCH_PAGE_SIZE)}>
            さらに100件表示（残り {(filteredPosts.length - visiblePosts.length).toLocaleString()} 件）
          </Button>
        </div>
      )}

      <FloatButton.Group shape="square" style={{ right: 94 }}>

        <Tooltip placement="left" title={t("storage.loadMore")} color="green">

          <FloatButton
            ref={ref1}
            icon={<PlusOutlined />}
            onClick={globalSearch
              ? () => setSearchVisibleCount((n) => n + SEARCH_PAGE_SIZE)
              : increment}
            tooltip={globalSearch ? "検索結果をさらに表示" : t("storage.loadMore")}
          />

        </Tooltip>



        <Tooltip

          placement="left"

          title={t("storage.downloadTimeSeries")}

          color="green"

        >

          <FloatButton

            ref={ref2}

            icon={<CloudDownloadOutlined />}

            onClick={downloadTimeSeries}

          />

        </Tooltip>



        <Tooltip placement="left" title={t("storage.viewGuide")} color="green">

          <FloatButton

            icon={<QuestionCircleOutlined />}

            onClick={() => setOpenTour(true)}

          />

        </Tooltip>

      </FloatButton.Group>



      {/* 単体削除 */}

      <Modal

        title={t("confirm.deleteTitle")}

        open={isModalOpen}

        onOk={handleOk}

        okType="danger"

        okText={t("common.yes")}

        onCancel={handleCancel}

        cancelText={t("common.no")}

      >

        <p>{t("confirm.deleteContent")}</p>

      </Modal>



      {/* 一括削除 */}

      <Modal

        title={t("confirm.bulkDeleteTitle")}

        open={isBulkDeleteModalOpen}

        onOk={async () => {

          const email = getAuth().currentUser?.email;

          if (!email) return;



          const keys = bulkDeleteKeys;



          try {

            // ★ まとめて並列削除（速い）

            await Promise.all(

              keys.map((path) => deleteDoc(doc(db, email, path.toString())))

            );



            // ★ ローカルから一気に消す（再取得しない）

            const keySet = new Set(keys);

            setPosts((prev) => prev.filter((p) => !keySet.has(recordId(p))));
            removeFromSearchCache(keys);

            setSelectedKeys(new Set());

            setIsBulkDeleteModalOpen(false);



            message.success(

              t("storage.deleteSuccess", { defaultValue: "Deleted." })

            );

          } catch (e) {

            console.error(e);

            message.error(

              t("common.updateFailed", { defaultValue: "Update failed." })

            );

          }

        }}

        okType="danger"

        okText={t("common.ok")}

        onCancel={() => setIsBulkDeleteModalOpen(false)}

        cancelText={t("common.no")}

      >

        <p>{t("confirm.bulkDeleteContent", { count: bulkDeleteKeys.length })}</p>

      </Modal>



      {/* 編集 */}

      <Modal

        open={open}

        title={t("storage.editTitle")}

        onOk={EdithandleOk}

        onCancel={EdithandleCancel}

        footer={[

          <Button key="back" onClick={EdithandleCancel}>

            {t("common.cancel")}

          </Button>,

          <Button

            key="submit"

            type="primary"

            loading={saving}

            onClick={EdithandleOk}

          >

            {t("common.change")}

          </Button>,

        ]}

      >

        <Form>

          {[

            { label: t("output_form.date"), key: "date", disabled: true },

            {

              label: t("output_form.cultivar"),

              key: "cultiverName",

              disabled: true,

            },

            {

              label: t("output_form.aperture"),

              key: "aperture",

              disabled: true,

            },

            { label: t("output_form.count"), key: "size", disabled: true },

            { label: t("output_form.location"), key: "location" },

            {

              label: t("output_form.temperature"),

              key: "temperture",

              type: "number",

              min: -10,

              max: 50,

            },

            {

              label: t("output_form.humidity"),

              key: "humidity",

              type: "number",

              min: 0,

              max: 100,

            },

            { label: t("output_form.weather"), key: "wether" },

            {

              label: t("output_form.memo"),

              key: "freeText",

              component: TextArea,

              rows: 4,

            },

            { label: t("output_form.priority"), key: "important", isSelect: true },

          ].map(({ label, key, isSelect, component: CustomComponent, ...props }) => (

            <div key={key} style={{ marginBottom: 12 }}>

              <div className="resultText">{label}</div>

              {isSelect ? (

                <Select

                  style={{ width: "100%" }}

                  value={editFields[key] || ""}

                  onChange={(value) =>

                    setEditFields({ ...editFields, [key]: value })

                  }

                  options={[

                    { label: t("output_form.none"), value: "" },

                    { label: "★", value: "★" },

                    { label: "★★", value: "★★" },

                    { label: "★★★", value: "★★★" },

                  ]}

                />

              ) : CustomComponent ? (

                <CustomComponent

                  {...props}

                  value={editFields[key]}

                  onChange={(e) =>

                    setEditFields({ ...editFields, [key]: e.target.value })

                  }

                />

              ) : (

                <Input

                  {...props}

                  value={editFields[key]}

                  onChange={(e) =>

                    setEditFields({ ...editFields, [key]: e.target.value })

                  }

                />

              )}

            </div>

          ))}

        </Form>

      </Modal>

    </>

  );

}



export default Storage;
